import React, { useState } from 'react';
import clsx from 'clsx';
import { makeStyles } from '@material-ui/core/styles';
import CssBaseline from '@material-ui/core/CssBaseline';
import Button from '@material-ui/core/Button';
import TextField from '@material-ui/core/TextField';
import Drawer from '@material-ui/core/Drawer';
import Popover from '@material-ui/core/Popover';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import List from '@material-ui/core/List';
import Paper from '@material-ui/core/Paper';
import Fab from '@material-ui/core/Fab';
import Typography from '@material-ui/core/Typography';
import Divider from '@material-ui/core/Divider';
import IconButton from '@material-ui/core/IconButton';
import Badge from '@material-ui/core/Badge';
import Container from '@material-ui/core/Container';
import Link from '@material-ui/core/Link';
import MenuIcon from '@material-ui/icons/Menu';
import ChevronLeftIcon from '@material-ui/icons/ChevronLeft';
import NotificationsIcon from '@material-ui/icons/Notifications';
import { MainListItems } from './NavigationItems';
import { withRouter } from 'react-router-dom';
import UIContext from '../contexts/uiContext'
import ClarityImage from '../images/clarity.png'
import SearchIcon from '@material-ui/icons/Search';
import AddIcon from '@material-ui/icons/Add';
import SettingsIcon from '@material-ui/icons/Settings';
import MoreIcon from '@material-ui/icons/MoreVert';

function MadeWithLove() {
    return (
        <Typography variant="body2" color="textSecondary" align="center">
            {'Built with love by the '}
            <Link color="inherit" href="https://material-ui.com/">
                Material-UI
      </Link>
            {' team.'}
        </Typography>
    );
}

const drawerWidth = 400;

const useStyles = makeStyles(theme => ({
    bodyItem: {
        //height: "93.5vh!important"
    },
    bottomAppBar: {
        top: 'auto',
        bottom: 0,
        zIndex: 100,
        boxShadow: '0px -2px 4px -1px rgba(0,0,0,0.2), 0px -4px 5px 0px rgba(0,0,0,0.14), 0px -1px 10px 0px rgba(0,0,0,0.12)',
        marginBottom: 0,
    },
    fabButton: {
        position: 'absolute',
        zIndex: 1,
        top: -30,
        left: 0,
        right: 0,
        margin: '0 auto',
    },
    root: {
        display: 'flex',
    },
    toolbar: {
        paddingRight: 24, // keep right padding when drawer closed
    },
    hidden: {
        display: 'none'
    },
    reverse: {
        transform: 'rotate(-180deg)'
    },
    toolbarIcon: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'flex-end',
        padding: '0 8px',
        ...theme.mixins.toolbar,
        minHeight: "48px!important",
        height: 48,
    },
    rightToolbarIcon: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'flex-start',
        padding: '0 8px',
        backgroundColor: '#0d47a1',
        color: 'white',
        ...theme.mixins.toolbar,
    },
    appBar: {
        zIndex: theme.zIndex.drawer + 1,
        transition: theme.transitions.create(['width', 'margin'], {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.leavingScreen,
        }),
    },
    appBarShift: {
        marginLeft: drawerWidth,
        width: window.elevation && `calc(100% - ${drawerWidth}px)` || '100%',
        transition: theme.transitions.create(['width', 'margin'], {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.enteringScreen,
        }),
    },
    menuButton: {
        marginRight: 36,
    },
    menuButtonHidden: {
        display: 'none',
    },
    title: {
        flexGrow: 1,
    },
    drawerPaper: {
        position: 'relative',
        whiteSpace: 'nowrap',
        width: drawerWidth,
        transition: theme.transitions.create('width', {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.enteringScreen,
        }),
    },
    drawerPaperRight: {
        position: 'relative',
        whiteSpace: 'nowrap',
        width: drawerWidth * 1.5,
        transition: theme.transitions.create('width', {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.enteringScreen,
        }),
    },
    drawerLeftRoot: {
        ul: {
            flexGrow: 1
            }
    },
    drawerRightRoot: {
        marginLeft: '1em',
        height: "calc(100vh - 128px) !important",
        flex: '0 1 auto',
        marginTop: 64,
        //borderLeft: '1px solid #3f51b57a',
        //boxShadow: '-2px 0px 4px -1px rgba(0,0,0,0.2), -4px 9px 5px 0px rgba(0,0,0,0.14), -1px 0px 10px 0px rgba(0,0,0,0.12)'
        boxShadow: '0px 1px 3px 0px rgba(0,0,0,0.2), 0px 1px 1px 0px rgba(0,0,0,0.14), 0px 2px 1px -1px rgba(0,0,0,0.12)'
    },
    drawrRightRootOpen: {
        //minWidth: 340,
    },

    drawerPaperClose: {
        overflowX: 'hidden',
        transition: theme.transitions.create('width', {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.leavingScreen,
        }),
        width: theme.spacing(7),
        //[theme.breakpoints.up('sm')]: {
        //    width: theme.spacing(9),
        //},
    },
    drawerRightPaperClose: {
        overflowX: 'hidden',
        transition: theme.transitions.create('width', {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.leavingScreen,
        }),
        width: 0,//theme.spacing(7),
        [theme.breakpoints.up('sm')]: {
            width: 0, //theme.spacing(9),
        },
    },
    appBarSpacer: theme.mixins.toolbar,
    content: {
        flexGrow: 1,
        height: '100vh',
        overflow: 'hidden',
    },
    container: {
        paddingLeft: theme.spacing(1),
        paddingRight: theme.spacing(1),
        height: 'calc(100vh - 128px)!important',
        overflow: 'auto'
    },
    paper: {
        padding: theme.spacing(2),
        display: 'flex',
        overflow: 'auto',
        flexDirection: 'column',
    },
    grow: {
        flexGrow: 1,
    },
    text: {
        padding: theme.spacing(2, 2, 0),
    },
    paper: {
        paddingBottom: 50,
    },
    list: {
        marginBottom: theme.spacing(2),
    },
    subheader: {
        backgroundColor: theme.palette.background.paper,
    },
    clarityImage: {
        width: "200px",
        position: "relative",
        left: 26
    },
    leftList: {
        flexGrow: 1,
        paddingTop:0
    },
    rightSidebarIcon: {
        color:'white'
    }
}));

export default withRouter(function Dashboard(props) {
    const classes = useStyles();

    const [anchorEl, setAnchorEl] = React.useState(null);

    const handleClick = event => {
        setAnchorEl(event.currentTarget);
    };

    const clearCache = event => {
        window.localStorage.clear();
        window.location.reload();
    }

    const handleClose = () => {
        setAnchorEl(null);
    };

    const open = Boolean(anchorEl);
    const id = open ? 'simple-popover' : undefined;

    const [loginAnchorEl, setLoginAnchorEl] = React.useState(null);

    const handleLoginClick = event => {
        setLoginAnchorEl(event.currentTarget);
    };    

    const handleLoginClose = () => {
        setLoginAnchorEl(null);
    };

    const loginOpen = Boolean(loginAnchorEl);
    const loginId = loginOpen ? 'simple-popover' : undefined;


    const handleLoginToSiteClick = event => {
        if ((usernameValue == 'chris' && passwordValue == 'chris')
            || (usernameValue == 'bruce' && passwordValue == 'bruce')
            || (usernameValue == 'accurate' && passwordValue == 'Accuratemap')            
            || (usernameValue == 'lrgadvanced' && passwordValue == 'Lrgadvanced1!')) {
            sessionStorage.setItem('loggedIn', "true");
            handleLoginClose();
        }
        else sessionStorage.setItem('loggedIn', "false");
    };

    const handleLogoutClick = event => {
        sessionStorage.setItem('loggedIn', "false");
        window.location.reload();
    }

    let userSettings = JSON.parse(localStorage.getItem("userSettings"));

    let fromDbLeftSidebarOpen = userSettings["leftSidebarOpen"];
    const [leftSidebarOpen, setLeftSidebarOpen] = React.useState(fromDbLeftSidebarOpen === undefined ? true : fromDbLeftSidebarOpen);
    const [rightSidebarOpen, setRightSidebarOpen] = React.useState(false);
    const [detailDrawerHeaderSection, setDetailDrawerHeaderSection] = React.useState("Detail Sidebar");
    const [detailDrawerBodySection, setDetailDrawerBodySection] = React.useState("");
    const [pageTitle, setPageTitle] = React.useState("");


    let persistSidebarOpen = (value) => {
        let userSettings = JSON.parse(localStorage.getItem("userSettings"));
        userSettings["leftSidebarOpen"] = value;
        localStorage.setItem("userSettings", JSON.stringify(userSettings));
    }

    const handleDrawerLeftSidebarOpen = () => {
        setLeftSidebarOpen(true);
        persistSidebarOpen(true);
    };
    const handleDrawerRightSidebarOpen = () => {
        setRightSidebarOpen(!rightSidebarOpen);
    };
    const handleLeftDrawerClose = () => {
        setLeftSidebarOpen(false);
        persistSidebarOpen(false);
    };
    const handleRightDrawerClose = () => {
        setRightSidebarOpen(false);
    };

    const setPageTitleFunc = (newPageTitle) => {
        setPageTitle(newPageTitle);
    };

    let hiddenRightContent = (true ? classes.hidden : "");

    let [usernameValue, setUsernameValue] = useState('');
    let [passwordValue, setPasswordValue] = useState('');

    let handleSetUsername = (sender, args) => {
        setUsernameValue(sender.currentTarget.value);
    };

    let handleSetPassword = (sender, args) => {
        setPasswordValue(sender.currentTarget.value);
    };


    return (
        <UIContext.Provider value={{ openDetailPane: setRightSidebarOpen, setDetailHeader: setDetailDrawerHeaderSection, setDetailBody: setDetailDrawerBodySection, setPageTitle: setPageTitleFunc, pageTitle: pageTitle }}>
            <div className={classes.root}>
                <CssBaseline />
                <AppBar position="absolute" className={clsx(classes.appBar, leftSidebarOpen && classes.appBarShift)}>
                    <Toolbar className={classes.toolbar} variant="dense">
                        <IconButton
                            edge="start"
                            color="inherit"
                            aria-label="Open drawer"
                            onClick={handleDrawerLeftSidebarOpen}
                            className={clsx(classes.menuButton, leftSidebarOpen && classes.menuButtonHidden)}
                        >
                            <MenuIcon />
                        </IconButton>
                        <Typography component="h1" variant="h6" color="inherit" className={classes.title}>
                            {pageTitle}
                        </Typography>


                        <Button aria-describedby={id} variant="contained" color="primary" onClick={clearCache} style={{ float: 'right', boxShadow: 'none' }}>
                            Clear Cache
                        </Button>
                        <Button aria-describedby={id} variant="contained" color="primary" onClick={handleClick} style={{ float: 'right', boxShadow: 'none' }}>
                            Disclaimer
                        </Button>
                        
                       
                        <Popover
                            id={id}
                            open={open}
                            anchorEl={anchorEl}
                            onClose={handleClose}
                            anchorOrigin={{
                                vertical: 'bottom',
                                horizontal: 'right',
                            }}
                            transformOrigin={{
                                vertical: 'top',
                                horizontal: 'right',
                            }}
                        >
                            <Typography className={classes.typography} style={{ width: 300 }}>
                                <div style={{ padding: '1em' }}>
                                    <b>DISCLAIMERS - </b><span style={{ lineHeight: 1, fontSize: 12 }}>This map is intended only as a summary of coverage and is provided on an on an "as is" and "as available" basis.." No representations or warranties are made as to the accuracy or currentness of the statistics and data provided on this map, or the continued or current availability of any coverage indicated on the map. For specific, current information relating to coverage in any particular state or jurisdiction, please contact administrator.  The coverage statistics provided on the are calculated based on (1) percentage of jurisdictions where court or arrest data is being accessed, and (2) the percentage of the population in the state that resides in jurisdictions where court and/or arrest data is being accessed. NOTE: Court or arrest data coverage in a particular jurisdiction does not mean that data is accessed in that jurisdiction from every court or arrest source. For example, in WV court data is only available from Circuit Courts,  and in AR District Court data is limited to District Courts reporting to the AOC.  To the fullest extent permitted by applicable law, we shall not be liable for any damages of any kind, including, but not limited to, direct, indirect, incidental, consequential, and/or punitive damages, arising from the use of this coverage map and/or the data/information represented therein.</span>
                                    <br />
                                    <br />
                                    <b>DISCLAIMER OF WARRANTIES AND LIMITATION OF LIABILITY - </b><span style={{ lineHeight: 1, fontSize: 12 }}>WE PROVIDE THIS WEBSITE ON AN "AS IS" AND "AS AVAILABLE" BASIS. WE MAKE NO REPRESENTATIONS OR WARRANTIES OF ANY KIND, EXPRESS OR IMPLIED, AS TO THE OPERATION OF THIS WEBSITE, OR THE CONTENT, INFORMATION, OR SERVICES PROVIDED TO YOU THROUGH OUR WEBSITE OR SOFTWARE. YOU FURTHER AGREE THAT WE ARE IN NO WAY RESPONSIBLE FOR ANY INACCURACIES, OR LIABILITY ARISING OUT OF INACCURACIES, IN DATA PROVIDED THROUGH THIS WEBSITE. YOU AGREE THAT YOUR USE OF THIS WEBSITE AT YOUR SOLE RISK. TO THE FULLEST EXTENT PERMITTED BY APPLICABLE LAW, WE DISCLAIM ALL WARRANTIES, EXPRESS AND IMPLIED, INCLUDING, BUT NOT LIMITED TO, IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE. WE WILL NOT BE LIABLE FOR ANY DAMAGES OF ANY KIND ARISING FROM THE USE OF THIS SITE, OUR SOFTWARE, and OUR SERVICES INCLUDING, BUT NOT LIMITED TO, DIRECT, INDIRECT, INCIDENTAL, CONSEQUENTIAL, AND PUNITIVE DAMAGES.</span>
                                </div>
                            </Typography>
                        </Popover>

                        {props.location.pathname == "/advanced" && sessionStorage.getItem('loggedIn') != 'true' && (<Button aria-describedby={id} variant="contained" color="primary" onClick={handleLoginClick} style={{ float: 'right', boxShadow: 'none' }}>
                            Login
                        </Button>)}
                        {props.location.pathname == "/advanced" && sessionStorage.getItem('loggedIn') == 'true' && (<Button aria-describedby={id} variant="contained" color="primary" onClick={handleLogoutClick} style={{ float: 'right', boxShadow: 'none' }}>
                            Logout
                        </Button>)}
                        <Popover
                            id={loginId}
                            open={loginOpen}
                            anchorEl={loginAnchorEl}
                            onClose={handleLoginClose}
                            anchorOrigin={{
                                vertical: 'bottom',
                                horizontal: 'center',
                            }}
                            transformOrigin={{
                                vertical: 'top',
                                horizontal: 'center',
                            }}
                        >
                            <Paper>
                                <Typography className={classes.typography} style={{ width: 300 }}>
                                    <div style={{ padding: '1em' }}>
                                        <TextField id="standard-basic" label="Username" value={usernameValue} onChange={handleSetUsername} />
                                        <br/>
                                        <TextField id="standard-basic" label="Password" type="password" value={passwordValue} onChange={handleSetPassword} />
                                        <br />
                                        <br />
                                        <Button aria-describedby={id} variant="contained" color="primary" onClick={handleLoginToSiteClick} >
                                            Login
                                        </Button>
                                    </div>
                                    </Typography>
                            </Paper>
                        </Popover>
                    </Toolbar>
                </AppBar>
                {window.elevation && (<Drawer
                    variant="permanent"
                    classes={{
                        paper: clsx(classes.bodyItem, classes.drawerPaper, !leftSidebarOpen && classes.drawerPaperClose),
                        root: clsx(classes.drawerLeftRoot)
                    }}
                    open={leftSidebarOpen}
                >
                    <div className={classes.toolbarIcon} style={{ backgroundColor: '#0d47a1' }} >

                        <Typography component="h1" variant="h6" color="inherit" noWrap className={clsx(classes.title)} style={{ color: 'white', marginLeft: 25 }}>
                            Monitoring Coverage
                        </Typography>

                        <IconButton onClick={handleLeftDrawerClose}>
                            <ChevronLeftIcon style={{ color: 'white' }} />
                        </IconButton>

                    </div>
                    <List className={clsx(classes.leftList)}><MainListItems /></List>
                    {/*<Divider />
        <List>{secondaryListItems}</List>*/}
                </Drawer>)}
                <main className={clsx(classes.bodyItem, classes.content)}>
                    <div className={classes.appBarSpacer} />
                    {!window.elevation && (<Typography component="h1" variant="h6" color="inherit" className={clsx(classes.title, "map-header-text")} style={{ marginLeft: 25, marginBottom: 10 }}>
                        Below are maps showing complete or partial coverage for both court and arrest sources as of {(new Date()).toLocaleDateString()}
                    </Typography>)}
                    <Container className={classes.container}>
                        {props.children}
                    </Container>
                </main>
            </div>
        </UIContext.Provider>
    );
});
